export default __webpack_public_path__ + "static/media/Mjolnir.ebdd53bb.png";